var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notice-dialog',{attrs:{"show":_vm.is_show,"title":_vm.title,"message":_vm.content,"primary-text":"關閉","primary-type":"main-color"},on:{"update:show":function($event){_vm.is_show=$event},"primary":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }